import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=540f47ac&scoped=true&"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f47ac",
  null
  
)

export default component.exports